import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_BEFORE } from '../data/drum';
const recap = ['6 volumes', '5 bonuses', '240 pages', 'Ages 6 to adult'];
const reassurances = ['Instant digital download', 'Print-ready PDF', '7-day money-back guarantee'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-112" data-mp="15c2fjcfz4tth">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-113" data-mp="1jbah2bzm0e0u" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-114" data-mp="1t2ydysexqn9p">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-115" data-mp="1t2ew1bpabyvo">
          Your drum studio can be <em className="text-red-700" data-id="element-116" data-mp="1o67pphsz8ld7">fully planned – starting today.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-117" data-mp="221juyj4rdu8d">
          Instead of searching for ideas, making every worksheet yourself and spending Sunday nights
          planning, you have one organized package for the whole studio year. More time for what
          really matters:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-118" data-mp="x41yy9lwlldh">
          Your students. Your music. Your life outside the studio.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-119" data-mp="120sfsz5j8kzy">
          {recap.map(item => <li key={item} data-id="element-120" data-mp="1b31kv9i17m5y">{item}</li>)}
        </ul>

        <p className="mt-8 text-lg text-slate-900/60" data-id="element-121" data-mp="1b1qm5o3g14lp">Before <s data-id="element-122" data-mp="1fu052k6554eh">{PRICE_BEFORE}</s></p>
        <p className="mt-2 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1fus09tvtt048">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1ksl9ywwc8c99">One-time payment – no subscription.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1puaia4s6ebtn">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1ttjd7cyycfqs" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1troorooh25hy">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3lw44dg66zcag">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3ltre8fqa5vmb" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}